module.exports = __webpack_public_path__ + "img/submit-article.097b9a0e.svg";